import { useEffect, useState } from "react";
import {
    View,
} from "react-native";

import { useNavigate, useLocation } from 'react-router-dom';

import { SideBarSubItemData } from "./sideBarData";
import { CSSProperties } from "styled-components";


interface SideBarCollapsedMenuSubItemProps {
    key: number,
    item: Readonly<SideBarSubItemData>
}

export default function SideBarCollapsedMenuSubItem(props:SideBarCollapsedMenuSubItemProps) {
    const [menuSubItemContainerStyle, setMenuSubItemContainerStyle] = useState(className.menuSubItemContainer);
    const [menuSubItemMouseActiveYn, setMenuSubItemMouseActiveYn] = useState(false);
    const [menuSubItemMouseHoverYn, setMenuSubItemMouseHoverYn] = useState(false);
    
    const inactiveContainerBackgroundColor = "#212943";
    const activeContainerBackgroundColor = "#2a328c";
    
    const normalContainerTextColor = "#ffffff";
    const hoverContainerTextColor = "#ffffff";

    const navigate = useNavigate();
    const path = useLocation().pathname;

    useEffect(() => {
        setCurrentPath(props.item.path);
    });


    useEffect(() => {
        if(menuSubItemMouseHoverYn) {
            setMenuSubItemContainerStyle({...className.menuSubItemContainer, backgroundColor: activeContainerBackgroundColor, color: hoverContainerTextColor});
        } else {
            if(menuSubItemMouseActiveYn) {
                setMenuSubItemContainerStyle({...className.menuSubItemContainer, backgroundColor: activeContainerBackgroundColor, color: hoverContainerTextColor});
            } else {
                setMenuSubItemContainerStyle({...className.menuSubItemContainer, backgroundColor: inactiveContainerBackgroundColor, color: normalContainerTextColor});
            }
        }
    }, [menuSubItemMouseHoverYn]);

    useEffect(() => {
        if(menuSubItemMouseActiveYn) {
            setMenuSubItemContainerStyle({...className.menuSubItemContainer, backgroundColor: activeContainerBackgroundColor, color: hoverContainerTextColor});
        } else {
            setMenuSubItemContainerStyle({...className.menuSubItemContainer, backgroundColor: inactiveContainerBackgroundColor, color: normalContainerTextColor});
        }
    }, [menuSubItemMouseActiveYn]);


    function setCurrentPath(itemPath) {
        if(path === itemPath) {
            setMenuSubItemMouseActiveYn(true);
        } else {
            setMenuSubItemMouseActiveYn(false);
        }
    }

    function clickMenuLink(linkTarget) {
        navigate(linkTarget);
    }

    return (
        <View>
            <div 
                style={menuSubItemContainerStyle}
                onClick={()=>{clickMenuLink(props.item.path)}}
                onMouseOut={()=>{setMenuSubItemMouseHoverYn(false)}}
                onMouseOver={()=>{setMenuSubItemMouseHoverYn(true)}}
            >
                {props.item.name}
            </div>
        </View>
    );
}

const className = {
    menuSubItemContainer: {
        minWidth: "160px",
        height: "14px",
        display: "flex",
        padding: "8px 20px",
        cursor: "pointer",
        backgroundColor: "#212943",
        color: "#fff",
        textAlign: "left",
        fontFamily: "NotoSansKR-Medium",
        fontSize: "13px",
        fontWeight: "500",
        letterSpacing: -0.05,
    } as CSSProperties,

}